import { t } from '../../../../../../common/i18n.js'
import type { Language } from '../../../../../../common/types/i18n.js'
import type { MyTenurePayload } from '../../../../../../server/controllers/portal/dashboard-card-payloads.js'

export const MyTenureCard = ({ data, lang }: { data: MyTenurePayload; lang: Language }) => {
    const c = t.portal.dashboard.cards.my_tenure
    return (
        <>
            <span className="portal-card__value">
                {data.startDate ? c.value(data.years, data.months)(lang) : c.empty(lang)}
            </span>
            <span className="portal-card__subtext">{c.badges(data.badgeCount)(lang)}</span>
        </>
    )
}
